import React, { useMemo } from 'react'
import classnames from 'classnames'
import { Link } from '@reach/router'
import PropTypes from 'prop-types'

import Placeholder1 from '_assets/images/placeholder-1.png'
import { CLASS_TYPE } from '_constants/class'
import { Class } from '_models/'

import styles from './styles.css'

const ClassCard = ({ course }) => {
  const classUrl = `/class/${course.id}`
  const formattedType = useMemo(
    () => Object.values(CLASS_TYPE).find(item => item.type === course.type)?.name,
    [course.type]
  )

  return (
    <article className={styles['class-wrapper']}>
      <Link to={classUrl} className={styles['content-wrapper']}>
        <h1 className={classnames(styles.text, styles['class-name'])}>{course.name}</h1>
        <p className={classnames(styles.text, styles['class-type'])}>{formattedType}</p>
      </Link>
      <Link to={classUrl} className={styles['image-container']}>
        <img
          alt="Course Thumbnail"
          src={course.coverPhoto || Placeholder1}
          className={styles.image}
        />
      </Link>
    </article>
  )
}

ClassCard.propTypes = {
  course: PropTypes.instanceOf(Class).isRequired,
}
export default React.memo(ClassCard)
